export default __webpack_public_path__ + "static/media/Minicard_7c.6ffbe124.svg";